import React from 'react';

import { cn } from '@easydatasolution/ui-react/lib/utils';

interface DiamondNumberProps {
	number: number;
	className?: string;
}

export function DiamondNumber({ number, className }: DiamondNumberProps) {
	return (
		<div
			className={cn(
				"relative flex h-11 w-11 shrink-0 items-center justify-center text-2xl font-semibold text-secondary-700 after:absolute after:inset-0 after:z-30 after:block after:h-11 after:w-11 after:rotate-45 after:rounded after:bg-[#E6EFF7] after:content-['']",
				className,
			)}
		>
			<span className="z-50">{number}</span>
		</div>
	);
}
